import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from './Contexts/AuthContext';
import { useNavigate } from 'react-router-dom';
export const ProfileModal = (): JSX.Element => {

  const {signOut} = useAuth();
  const navi = useNavigate();
  
  async  function signOutHandler() 
  {
    await signOut();
    await navi('/')

  }

  return (
    <div className="px-3 py-5 absolute top-16 gap-4 w-[208px] bg-white border-[1px] rounded-md  shadow-lg  flex flex-col">
      <Link to={'/connect-data'}>
        <div className="flex items-center gap-2">
          <svg
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <mask
              id="mask0_338_55"
              maskUnits="userSpaceOnUse"
              x="0"
              y="0"
              width="14"
              height="14"
            >
              <path d="M14 0H0V14H14V0Z" fill="white" />
            </mask>
            <g mask="url(#mask0_338_55)">
              <path
                d="M12.546 8.45788L11.572 7.37588C11.617 7.0213 11.617 6.66246 11.572 6.30788L12.544 5.22688C12.6138 5.12815 12.6512 5.01025 12.6512 4.88938C12.6512 4.76851 12.6138 4.65061 12.544 4.55188L11.804 3.28588C11.75 3.17733 11.6645 3.08755 11.5588 3.02817C11.453 2.96879 11.3319 2.94256 11.211 2.95288L9.77704 3.24288C9.48654 3.02821 9.17169 2.84863 8.83904 2.70788L8.38104 1.33888C8.32871 1.22962 8.24453 1.13876 8.13958 1.07825C8.03463 1.01774 7.91382 0.990418 7.79304 0.99988H6.31204C6.19165 0.990456 6.07121 1.01758 5.96648 1.07771C5.86175 1.13783 5.7776 1.22816 5.72504 1.33688L5.26104 2.70688C4.92862 2.84707 4.61408 3.02633 4.32404 3.24088L2.88904 2.95388C2.76827 2.94307 2.64706 2.9691 2.54138 3.02854C2.4357 3.08799 2.35051 3.17806 2.29704 3.28688L1.55604 4.55288C1.48653 4.65151 1.44922 4.76922 1.44922 4.88988C1.44922 5.01054 1.48653 5.12825 1.55604 5.22688L2.52804 6.30888C2.48303 6.66312 2.48303 7.02164 2.52804 7.37588L1.56004 8.45788C1.49053 8.55651 1.45322 8.67422 1.45322 8.79488C1.45322 8.91554 1.49053 9.03325 1.56004 9.13188L2.29904 10.3999C2.35251 10.5087 2.4377 10.5988 2.54338 10.6582C2.64906 10.7177 2.77027 10.7437 2.89104 10.7329L4.32604 10.4439C4.61632 10.6581 4.93082 10.8373 5.26304 10.9779L5.72704 12.3469C5.7796 12.4556 5.86375 12.5459 5.96848 12.6061C6.07321 12.6662 6.19365 12.6933 6.31404 12.6839H7.79904C7.91943 12.6933 8.03987 12.6662 8.1446 12.6061C8.24932 12.5459 8.33347 12.4556 8.38604 12.3469L8.84904 10.9779C9.18169 10.8375 9.49655 10.6583 9.78704 10.4439L11.221 10.7329C11.3418 10.7437 11.463 10.7177 11.5687 10.6582C11.6744 10.5988 11.7596 10.5087 11.813 10.3999L12.554 9.13388C12.6231 9.03434 12.6595 8.91575 12.658 8.7946C12.6566 8.67345 12.6174 8.55576 12.546 8.45788ZM7.02404 9.08888C6.58057 9.08355 6.14859 8.94717 5.78246 8.6969C5.41632 8.44662 5.1324 8.09364 4.96641 7.68238C4.80043 7.27111 4.75981 6.81993 4.84965 6.38563C4.9395 5.95133 5.1558 5.55331 5.47134 5.24165C5.78687 4.93 6.18754 4.71864 6.62292 4.63418C7.05831 4.54972 7.50894 4.59593 7.91812 4.767C8.3273 4.93806 8.67674 5.22633 8.92246 5.59554C9.16818 5.96474 9.2992 6.39838 9.29904 6.84188C9.29893 7.13942 9.23978 7.43399 9.12501 7.70851C9.01024 7.98303 8.84214 8.23205 8.63045 8.44114C8.41876 8.65023 8.16768 8.81523 7.89176 8.92659C7.61584 9.03795 7.32056 9.09345 7.02304 9.08988L7.02404 9.08888Z"
                stroke="#A1A7B1"
                strokeWidth="1.2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </g>
          </svg>
          <div className="font-medium text-[#474a4e] text-[14px]">
            데이터 연동
          </div>
        </div>
      </Link>

        <div onClick={signOutHandler} className="flex cursor-pointer items-center  gap-2">
          <svg
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clipPath="url(#clip0_144_756)">
              <mask
                id="mask0_144_756"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="14"
                height="14"
              >
                <path d="M14 0H0V14H14V0Z" fill="white" />
              </mask>
              <g mask="url(#mask0_144_756)">
                <path
                  d="M8 1H1V13H8"
                  stroke="#A1A7B1"
                  strokeWidth="1.2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M6 7H12"
                  stroke="#A1A7B1"
                  strokeWidth="1.2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M10 4L13 7L10 10"
                  stroke="#A1A7B1"
                  strokeWidth="1.2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </g>
            </g>
            <defs>
              <clipPath id="clip0_144_756">
                <rect width="14" height="14" fill="white" />
              </clipPath>
            </defs>
          </svg>
          <div className="font-medium text-[#474a4e] text-[14px]">로그아웃</div>
        </div>
    </div>
  );
};
